import { BackgroundAction } from '../BackgroundAction'
import { incomeBackgroundAction } from './api'

export const ExportBackgroundAction = new BackgroundAction({
  api: incomeBackgroundAction,
})

export const DownloadBackgroundAction = new BackgroundAction({
  api: incomeBackgroundAction,
})
